import Base from './Base'
import gsap from 'gsap'

import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()	

		let nextSteps = qs('.next-step')
		let prevSteps = qs('.prev-step')
		let firsStep = qs('.step-1')
		let secondStep = qs('.step-2')
		let steps = qsa('.steps')
		let check = false
		let inputs = firsStep.querySelectorAll('input,select,textarea')

		nextSteps &&
		nextSteps.addEventListener('click', ()=>{
			inputs.forEach(el => {
				check = el.checkValidity()
			});
			
			if(check){
				firsStep.classList.remove('active')
				secondStep.classList.add('active')
				console.log(check,'ok', steps)
			}else{
				gsap.to('#alert-form', {duration: .5,opacity:1,onComplete:()=>{
					setTimeout(function(){
						gsap.to('#alert-form', {duration: .5,opacity:0})
					},3000)
				}})
			}
		})
		prevSteps &&
		prevSteps.addEventListener('click', ()=>{			
			secondStep.classList.remove('active')
			firsStep.classList.add('active')
		})
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
}